import React from 'react';
import { compose } from 'recompose';
import { Row, Col, Form, FormGroup, Label, Input } from 'reactstrap';
import { BackButton } from 'components/common/Forms';
import moment from 'moment';
import withLifecycle from '@hocs/with-lifecycle';
import qs from 'query-string';


const ScrollToElementWithId = compose(
  withLifecycle({
    onDidMount: ({ location }) => {
      const hash = location.hash.replace("#", "");
      const element = document.getElementById(hash);
      if(!element || !element.scrollIntoView) return;
      setTimeout(() => element.scrollIntoView(), 100);
    },
  })
)(() => null);


export const InstallationReport = ({ data, onBack, location, ...props }) => (
  <div>
    <Row>
      <Col>
        {data && (
          <Form>
            <FormGroup row>
              <Label sm={4} md={3} lg={2}>
                Job Start Time:
              </Label>
              <Col sm={8} md={9} lg={10}>
                <Input
                  disabled
                  value={moment(data.start_time).format('YYYY-MM-DD HH:mm')}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={4} md={3} lg={2}>
                Job Finish Time:
              </Label>
              <Col sm={8} md={9} lg={10}>
                <Input
                  disabled
                  value={moment(data.finish_time).format('YYYY-MM-DD HH:mm')}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={4} md={4} lg={3}>
                Device Placement:
              </Label>
              <Col sm={8} md={8} lg={9}>
                <img
                  src={data.device_placement_image}
                  style={{ maxWidth: '40vw', border: '1px solid grey' }}
                  alt="Device placement shown on Vehicle Diagram"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={4} md={4} lg={3}>
                Technician Signature:
              </Label>
              <Col sm={8} md={8} lg={9}>
                <img
                  src={data.signature_technician_image}
                  style={{ maxWidth: '40vw', border: '1px solid grey' }}
                  alt="Signature of Installating Technician"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={4} md={4} lg={3}>
                Customer Signature:
              </Label>
              <Col sm={8} md={8} lg={9}>
                <img
                  src={data.signature_customer_image}
                  style={{ maxWidth: '40vw', border: '1px solid grey' }}
                  alt="Signature of Customer"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={4} md={3} lg={2}>
                Comments:
              </Label>
              <Col sm={8} md={9} lg={10}>
                <Input
                  type="textarea"
                  rows={10}
                  disabled
                  value={data.comments}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={4} md={3} lg={2}>
                Vehicle Condition:
              </Label>
              <Col sm={8} md={9} lg={10}>
                <Input
                  type="textarea"
                  rows={10}
                  disabled
                  value={data.vehicle_condition}
                />
              </Col>
            </FormGroup>
            {data.pdf_file && (
              <FormGroup row>
                <ScrollToElementWithId location={location} />
                <Label sm={4} md={3} lg={2}>
                  PDF Report:
                </Label>
                <Col sm={8} md={9} lg={10}>
                  <div>
                    <a href={data.pdf_file} target="_blank" id="pdf" className={location.hash.replace("#", "") === 'pdf' ? "target" : ""}>
                      <span
                        className="fa fa-file-pdf-o"
                        style={{ fontSize: '4em' }}
                      />
                    </a>
                  </div>
                </Col>
              </FormGroup>
            )}
          </Form>
        )}
      </Col>
    </Row>
    <BackButton className="float-right mr-2" onClick={onBack} />
  </div>
);

const enhance = compose();

export default enhance(InstallationReport);



// WEBPACK FOOTER //
// ./src/pages/Jobs/InstallationReport.jsx